<template>
<label :class="_class">
    <input 
    v-bind:type="type"
    v-bind="$attrs"
    v-bind:checked="checked"
    v-bind:name="name"
    :disabled="disabled"
    v-on:change="$emit('change', $event.target.checked)"/>
    <slot></slot>
    <span></span>
</label>    
</template>

<script>
export default {
    props: {
        type: {
            default: 'checkbox'
        },
        solid: {
            default: false,
        },
        bold: {
            default: false,
        },
        disabled: {
            default: false,
        },
        variant: {
            default: false,
        },
        checked: {
            type: [Boolean, Number],
            default: false
        },
        name: {
            type: String
        }
    },
    model: {
        prop: 'checked',
        event: 'change'
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('kt-'+this.type)

            if(this.solid) {
                _class.push('kt-'+this.type+'--solid')
            }
            
            if(this.bold) {
                _class.push('kt-'+this.type+'--bold')
            }
            
            if(this.disabled) {
                _class.push('kt-'+this.type+'--disabled')
            }

            if(this.variant) {
                _class.push('kt-'+this.type+'--variant')
            }
            return _class
        }
    }
}
</script>